import React from 'react';
import ImageRenderer from '@app/components/media-renderer/image-renderer';
import environments from '@app/configs/environments';
import { ProductAttributes } from '@app/models/dtos/strapi';
import { Typography } from '@mui/material';
import { useRouter } from 'next/router';

function ProductCard({ product }: { product: ProductAttributes }) {
    const router = useRouter();
    return (
        <div onClick={() => router.push(`/product/${product.slug}`)} className="flex cursor-pointer flex-col items-center justify-center gap-3 border  border-black-1 p-4">
            {product?.logo && <ImageRenderer media={environments.STRAPI_HOST_URL + product.logo.url} className="!h-fit !w-fit filter-none" isGrayScale={false} />}
            <Typography className="microCopy" noWrap>
                {product.name}
            </Typography>
        </div>
    );
}

export default ProductCard;
